import { Button } from "../../components/ui/button";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import { Input } from "../../components/ui/input";
import CustomLabelText from "../../components/CustomLabelText";
import { Label } from "../../components/ui/label";
import SearchSelect from "../../components/SearchSelect";
import ReactInputMask from "react-input-mask";
import { Textarea } from "../../components/ui/textarea";
import { API, fileUpload, get } from "../../config";
import Spin from "../../components/Spin";
import { AddChartOfAccountSchema } from "../../lib/Validation";

const AddEditChartOfAccount = ({
  id,
  toggleShowAddEditChartOfAccount,
  edit,
  accountId,
  accountTypesList,
  fetchAccountData,
  trustId,
}) => {
  const [chartOfAccountData, setChartOfAccountData] = useState([]);
  const [loading, setLoading] = useState(false);

  var accountTypeArray = [];
  // eslint-disable-next-line array-callback-return
  accountTypeArray = accountTypesList?.map((item) => {
    if (item.name === "Expenses" || item.name === "Revenue") {
      return { ...item, value: item.id, label: item.name };
    }
  });

  async function fetchData() {
    try {
      setLoading(true);
      const { data } = await get(`${API.ACCOUNT_DETAILS}/` + id);
      setChartOfAccountData(data.data);
      setLoading(false);
    } catch (e) {
      setChartOfAccountData(null);
    }
  }
  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const typeListArray = [
    { label: "Debit", value: "0" },
    { label: "Credit", value: "1" },
  ];

  const taxListArray = [
    { label: "GST on Income", value: "1" },
    { label: "GST Free Expenses", value: "0" },
    { label: "GST on Expenses", value: "2" },
    { label: "BAS Excluded", value: "3" },
  ];

  const handleFormSubmit = async (value, { setErrors, resetForm }) => {
    const formData = new FormData();
    value.account_type_id = value?.account_type_id
      ? value?.account_type_id
      : "";
    value.type = value?.type ? parseInt(value?.type) : "";
    value.tax = value?.tax ? parseInt(value?.tax) : 0;
    value.code = value?.code ? value?.code : "";
    value.sub_code = value?.sub_code ? value?.sub_code : "";
    value.accounting_code = value?.accounting_code
      ? parseInt(value?.accounting_code)
      : "";
    formData.append("trust_id", trustId);
    formData.append("account_type_id", value?.account_type_id);
    formData.append("type", value?.type);
    formData.append("tax", value?.tax);
    formData.append("code", value?.code);
    formData.append("accounting_code", value?.accounting_code);
    formData.append("sub_code", value?.sub_code);
    formData.append("name", value?.name ? value?.name : "");
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );
    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.ACCOUNT_ADD}${edit ? `/${id}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditChartOfAccount();
        fetchAccountData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{
        account_type_id: chartOfAccountData?.account_type_id
          ? accountTypeArray?.find(
              (item) => item?.value === chartOfAccountData?.account_type_id
            )?.value
          : accountTypeArray?.find(
              (item) =>
                item?.value ===
                (accountId ? accountId : accountTypeArray[0]?.value)
            )?.value,
        type: typeListArray?.find(
          (item) => parseInt(item?.value) === chartOfAccountData?.type
        )?.value,
        tax: taxListArray?.find(
          (item) => parseInt(item?.value) === chartOfAccountData?.tax
        )?.value,
        name: chartOfAccountData?.name,
        code: chartOfAccountData?.code,
        sub_code: chartOfAccountData?.sub_code,
        accounting_code: chartOfAccountData?.accounting_code,
        description: chartOfAccountData?.description,
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddChartOfAccountSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true}/>}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="grid gap-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="account_type_id">
                    <CustomLabelText
                      required={true}
                      labelText="Account Type"
                      errorField={errors?.account_type_id}
                    />
                  </Label>

                  <SearchSelect
                    frameworks={accountTypeArray}
                    optionType={"Account Type"}
                    handleSelect={(e) => {
                      setFieldValue("account_type_id", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.account_type_id &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={false}
                    initialValue={values?.account_type_id}
                  />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="type">
                    <CustomLabelText
                      required={true}
                      labelText="Type"
                      errorField={errors?.type}
                    />
                  </Label>

                  <SearchSelect
                    frameworks={typeListArray}
                    optionType={"Type"}
                    handleSelect={(e) => {
                      setFieldValue("type", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.type &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={false}
                    initialValue={values?.type}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="tax">
                    <CustomLabelText
                      required={true}
                      labelText="Tax"
                      errorField={errors?.tax}
                    />
                  </Label>

                  <SearchSelect
                    frameworks={taxListArray}
                    optionType={"Tax"}
                    handleSelect={(e) => {
                      setFieldValue("tax", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.tax && `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={false}
                    initialValue={values?.tax}
                  />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="name">
                    <CustomLabelText
                      required={true}
                      labelText="Name"
                      errorField={errors?.name}
                    />
                  </Label>
                  <Input
                    id="name"
                    type="text"
                    name="name"
                    value={values?.name ? values?.name : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.name &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="code">
                    <CustomLabelText
                      required={true}
                      labelText="TrustSoft Code"
                      errorField={errors?.code}
                    />
                  </Label>
                  <ReactInputMask
                    id="code"
                    type="text"
                    name="code"
                    value={values?.code ? values?.code : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    mask="999999999"
                    maskChar={null}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.code
                        ? `${cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )} focus-visible:ring-red-500 border-red-500`
                        : cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )
                    }
                  />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="sub_code">
                    <CustomLabelText
                      required={false}
                      labelText="TrustSoft Sub Code"
                      errorField={errors?.sub_code}
                    />
                  </Label>
                  <ReactInputMask
                    id="sub_code"
                    type="text"
                    name="sub_code"
                    value={values?.sub_code ? values?.sub_code : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    mask="999999999"
                    maskChar={null}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.sub_code
                        ? `${cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )} focus-visible:ring-red-500 border-red-500`
                        : cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )
                    }
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="accounting_code">
                    <CustomLabelText
                      required={false}
                      labelText="Accounting Software Code"
                      errorField={errors?.accounting_code}
                    />
                  </Label>
                  <ReactInputMask
                    id="accounting_code"
                    type="text"
                    name="accounting_code"
                    value={
                      values?.accounting_code ? values?.accounting_code : ""
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    mask="999999999"
                    maskChar={null}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.accounting_code
                        ? `${cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )} focus-visible:ring-red-500 border-red-500`
                        : cn(
                            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                          )
                    }
                  />
                </div>
              </div>
              <div className="grid gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="description">
                    <CustomLabelText
                      required={true}
                      labelText="Desription"
                      errorField={errors?.description}
                    />
                  </Label>
                  <Textarea
                    id="description"
                    name="description"
                    value={values?.description ? values?.description : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.description &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditChartOfAccount();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditChartOfAccount;
